import { useEffect, useRef, useState } from "react";
import Picker from "@emoji-mart/react";
import { BsFileTextFill } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
// import { v4 as uuid } from 'uuid'
import { useIsMutating, useQuery, useQueryClient } from "@tanstack/react-query";
import { ClientMessage } from "../client-message";
import { UserMessage } from "../user-message";
import { Templates } from '../templates'
import { FileButton } from '../file-button'
import { apiWhatsApp } from "../../../../../services/api";
import { MessageProps, TemplateProps, useChatWhatsApp } from "../../../../../context/ChatWhatsAppContext";
import { format } from "date-fns";
import { useAuth } from "../../../../../context/AuthContext";
import { QueueProps, useFila } from "../../../../../context/FilaContext";
// import { useModal } from "../../../../../hooks/ModalContext";
import { Loader } from "../../../../generics/loader";
import { StartButton } from './components/start-button'
import { GrEmoji } from "react-icons/gr";
import { IoSend } from "react-icons/io5";


interface ChatBoxProps {
  type: string;
}

interface MessagesChatProps {
  file?: {
    downloaded: [],
    attendantHasReceivedUpdate: boolean,
    url: string
    name?: string
  },
  read: {
    value: boolean
  },
  fromAttendant: boolean,
  _id: string,
  onlySave: boolean,
  type: string,
  chat: string,
  text?: string,
  createdAt: string,
  attendant?: string,
  template?: TemplateProps

}

export const ChatBox = ({ type }: ChatBoxProps) => {
  const queryClient = useQueryClient()
  const [showEmoji, setShowEmoji] = useState(false);
  const { enviarMessages, endChat, sendDoc, endOnTemplateChat } = useChatWhatsApp()
  const [messagesChat, setMessageChat] = useState<MessagesChatProps[]>([])
  const { devedorFilaSelected, getChatId, getDevedorFilaSelected, fila } = useFila()
  // const { setModal } = useModal()
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const { cookies } = useAuth()
  const isMutationChat = useIsMutating({ mutationKey: ['chat'] })


  const [fileState, setFileState] = useState<File | null>(null)
  const [text, setText] = useState("");


  const clientMess = messagesChat && Array.isArray(messagesChat) && messagesChat?.find((item: MessagesChatProps) => !item?.attendant && item._id) ? true : false

  const attendantFirstMessage = messagesChat && Array.isArray(messagesChat) && messagesChat?.find((item: MessagesChatProps) => item?.attendant && item._id && item.type === 'template') ? true : false


  useEffect(() => {
    const data = fila.find(item => item.cpf_cnpj === devedorFilaSelected?.cpf_cnpj)
    getDevedorFilaSelected(data || {} as QueueProps)
  }, [fila])

  const scrollToBottom = () => {
    const scrollContainer = scrollContainerRef.current;
    // Verifica se o contêiner de rolagem existe

    if (scrollContainer) {
      // Rola para o final do contêiner
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  };

  async function getMessages() {
    if (devedorFilaSelected?.id_chat && devedorFilaSelected?.cpf_cnpj) {
      return await apiWhatsApp.get(`/message/`, { params: { chatId: devedorFilaSelected.id_chat, updates: 'true' }, headers: { token: cookies?.whatsapp?.token } })
    }
  }

  const { data, refetch } = useQuery({
    queryFn: () => getMessages(),
    queryKey: ['firstMessages'],
    refetchInterval: 3000,
  })

  useEffect(() => {
    scrollToBottom()
  }, [messagesChat])

  useEffect(() => {
    setMessageChat(data?.data)
  }, [data?.data, devedorFilaSelected.id_chat])

  useEffect(() => {
    refetch()
    setMessageChat(data?.data)
  }, [devedorFilaSelected.id_chat])

  async function handleSend(dataMess: MessageProps) {
    await enviarMessages(dataMess)
    setText('')
    setShowEmoji(false)
    await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
  }

  async function handleFileSelect(file: File) {
    setFileState(file)
  };

  function clearFile() {
    setFileState(null)
  }

  function getBase64(file: File) {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  }


  async function sendFile(file: File) {
    const base64 = await getBase64(file)
    const token = cookies?.whatsapp?.token || ''
    const chat = devedorFilaSelected.id_chat || ''
    const [docType, data] = String(base64)?.split(';')
    const [, fileURL] = String(data)?.split(',')
    const docTypeFormated = docType?.replace('data:', '')
    const fileName = `${file.name}`

    await sendDoc({ chat, token, file: fileURL, contentType: docTypeFormated, fileName })
    setFileState(null)
  }

  function handleEmojiClick(emoji: any) {
    setText(text + emoji.native);
  }

  const handleKeyPress = async (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      await handleSend({
        type: 'text',
        text: !fileState ? text : '',
        onlySave: false,
        token: cookies?.whatsapp?.token || '',
        chat: devedorFilaSelected.id_chat
      })
    }
  };


  async function handleEndChat() {
    const id_chat = devedorFilaSelected.id_chat || ''
    const token = cookies?.whatsapp?.token || ''
    if (devedorFilaSelected && devedorFilaSelected?.id_chat && devedorFilaSelected?.cpf_cnpj && !clientMess) await endOnTemplateChat(id_chat, token)
    if (devedorFilaSelected && devedorFilaSelected.cpf_cnpj && devedorFilaSelected.id_chat && clientMess) await endChat(id_chat, token)
    setMessageChat([])
    await getChatId(Number(devedorFilaSelected.id_queue), '')
    await queryClient.refetchQueries({ queryKey: ['atendimento'] })
    // if (fila && devedorFilaSelected?.cpf_cnpj) {
    //   getDevedorFilaSelected(fila.find(item => item.cpf_cnpj === devedorFilaSelected?.cpf_cnpj) || {} as QueueProps)
    // }
  }

  return (
    <div className="w-full">
      <div className="fixed bottom-0 flex max-h-[86%]  w-full flex-grow flex-col rounded-lg bg-[#EEEAE3]  ">

        <div className="flex flex-grow  flex-col  overflow-y-auto overflow-x-hidden p-4 border border-primary h-screen rounded-sm" ref={scrollContainerRef}>
          <div className="">
            {devedorFilaSelected?.id_chat && <p className="w-full text-center text-primary font-semibold text-sm mb-4">Conversa iniciada</p>}
            {
              devedorFilaSelected?.id_chat && devedorFilaSelected?.cpf_cnpj && messagesChat && messagesChat?.length > 0 && messagesChat?.map(mess => (
                <>
                  {
                    mess.attendant && !mess.onlySave ? <UserMessage text={mess.text || ''} time={format(new Date(mess.createdAt), 'HH:mm')} linkImage={mess?.file?.url} template={mess.template} type={mess.type} documentName={mess?.file?.name} /> : !mess.attendant && !mess.onlySave ? <ClientMessage text={mess.text || ''} type={mess.type} linkImage={mess?.file?.url} time={format(new Date(mess.createdAt), 'HH:mm')} /> : <></>
                  }
                </>
              ))
            }
            {devedorFilaSelected && devedorFilaSelected?.id_chat && devedorFilaSelected?.cpf_cnpj && !clientMess && attendantFirstMessage && <p className="w-full text-center text-primary font-semibold text-sm mb-4">Aguardando reposta do cliente</p>}
          </div>
        </div>
        <div
          className={`${!showEmoji && "hidden"} absolute bottom-20 z-10 w-full`}
        >
          <Picker
            // data={data}
            onEmojiSelect={handleEmojiClick}
            locale={"pt"}
            previewPosition="none"
            theme="light"
            searchPosition="none"
            categories={["frequent", "people"]}
          />
        </div>
        <div className="flex items-center justify-between gap-2 flex-col bg-primary px-2 pb-4 pt-2">
          <StartButton />
          {devedorFilaSelected && devedorFilaSelected?.id_chat && devedorFilaSelected?.cpf_cnpj && !clientMess && <Templates />}


          <div className={`flex flex-col w-full `}>
            {/* <MessageBox type={type} setShowEmoji={setShowEmoji} showEmoji={showEmoji} clienteMess={clientMess} /> */}
            {
              devedorFilaSelected && devedorFilaSelected.cpf_cnpj && devedorFilaSelected.id_chat && clientMess && (
                <div className="flex items-center w-full justify-between">
                  <div className="flex h-10 w-full items-center  rounded bg-gray-100 px-2">
                    <button onClick={() => setShowEmoji(!showEmoji)}>
                      {/* <img src={emojiIcon} alt="" className="mr-2 h-4 w-4" /> */}
                      <GrEmoji size={20} color={'#696969'} />
                    </button>
                    {
                      fileState ? (<div className="w-full flex items-center h-10 text-xs justify-between px-2">

                        <BsFileTextFill size={16} className="fill-primary" />
                        <p className="w-[140px] text-ellipsis whitespace-nowrap overflow-hidden">Arquivo: {fileState?.name} </p>
                        <button onClick={() => clearFile()}>
                          <IoMdClose size={16} className="fill-primary" />
                        </button>


                      </div>) : (
                        <textarea
                          className="flex h-10 w-full resize-none items-center rounded bg-transparent px-2 pt-2.5 text-sm outline-none "
                          placeholder="Type your message…"
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          onKeyDown={handleKeyPress}
                        // onKeyDown={(e) => onEnter(e)}
                        />
                      )
                    }
                    {type !== "sms" && (
                      <>

                        <FileButton onFileSelect={handleFileSelect} />
                        {/* <button onClick={() => { }}> */}
                        {/* <img src={microfoneIcon} alt="" className="mr-2 h-5 w-5" /> */}
                        {/* </button> */}
                      </>
                    )}
                  </div>
                  <button className=" w-[10%] ml-4 text-center"
                    onClick={() => fileState ? sendFile(fileState) : handleSend({
                      type: 'text',
                      text: !fileState ? text : '',
                      onlySave: false,

                      token: cookies?.whatsapp?.token || '',
                      chat: devedorFilaSelected.id_chat
                    })}
                  >
                    <IoSend size={22} className="fill-white" />
                    {/* <img src={sendIcon} alt="" className="mr-2 h-6 w-6" /> */}
                  </button>
                </div>
              )
            }
            {devedorFilaSelected?.id_chat && devedorFilaSelected?.cpf_cnpj && <button className="p-1 w-full bg-red-600 text-xs text-white font-semibold rounded-md mt-2" onClick={() => handleEndChat()}>
              {!clientMess ? 'Cancelar conversa' : 'Encerrar conversa'}
            </button>}
            {/* {devedorFilaSelected?.id_chat && devedorFilaSelected?.cpf_cnpj && messagesChat.length > 0  && <button className="p-1 w-full bg-red-600 text-xs text-white font-semibold rounded-md mt-2" onClick={() => handleEndChat()}>
              {!clientMess ? 'Cancelar conversa' : 'Encerrar conversa'}
            </button>} */}
          </div>


        </div>
        {
          isMutationChat > 0 ? <div className=" flex justify-center  items-center min-h-[100%] w-[100%] absolute m bg-white opacity-90 z-50 px-4 py-4">
            <Loader size={3.5} />
          </div> : <></>
        }
      </div>

    </div>
  );
};
